/* eslint-disable no-unused-vars */

$(document).ready(function () {
  if ($('.js-invoice:checked').length > 0) {
    updateSummary();
  }
});

$('.js-pay-all-invoices').click((evt) => {
  $('.js-invoice').prop('checked', true);
  updateSummary();
  return false;
});

$('.js-pay-due-invoices').click((evt) => {
  $('.js-invoice').prop('checked', false);
  $('.js-invoice-due').prop('checked', true);
  updateSummary();
  return false;
});

$('.js-invoice').click((evt) => {
  updateSummary();
});

function updateSummary() {
  let rows = 0;
  let totalValue = 0;

  var payInvoicesForm = $('#pay-invoices-form');
  $('.js-invoice-id').remove();
  $('.js-invoice:checked').each(function (index) {
    rows++;
    var documentId = $(this).data('document-id');
    var price = $(this).data('price-outstanding');
    totalValue += parseFloat(price);
    payInvoicesForm.append(
      '<input type="hidden" class="js-invoice-id" name="Invoices[' +
        index +
        '].DocumentNumber" value="' +
        documentId +
        '" />'
    );
    payInvoicesForm.append(
      '<input type="hidden" class="js-invoice-id" name="Invoices[' +
        index +
        '].Amount" value="' +
        price +
        '" />'
    );
  });

  $('.js-invoice-count').text(rows);
  $('.js-invoice-total').text(totalValue.toFixed(2));
  $('#payment-value').val(totalValue.toFixed(2));
}
